export class EnquiryModel {
    name: string;
    email: string;
    contactNumber: string;
    message: string;
}
